// ============================================================================
// Mock Data - Sample Invoices
// ============================================================================

export const MOCK_INVOICES = [
    {
        id: 1,
        invoiceNumber: 'INV-2026-00042',
        companyName: 'Lumière Jewels',
        sellerName: 'Fine Jewellery',
        sellerCode: 'LMFJ08',
        serviceTypes: 'Rent',
        invoiceDate: '2026-04-23',
        dueDate: '2026-05-07',
        amount: -497,
    },
    {
        id: 2,
        invoiceNumber: 'INV-2026-00041',
        companyName: 'Lumière Jewels',
        sellerName: 'Silver & Stones',
        sellerCode: 'LMS500',
        serviceTypes: 'Rent',
        invoiceDate: '2026-04-22',
        dueDate: '2026-05-06',
        amount: -1240.5,
    },
    {
        id: 3,
        invoiceNumber: 'INV-2026-00040',
        companyName: 'Lumière Jewels',
        sellerName: 'Bridal Collection',
        sellerCode: 'LMBC80',
        serviceTypes: 'Inbound',
        invoiceDate: '2026-04-21',
        dueDate: '2026-05-05',
        amount: -580,
    },
    {
        id: 4,
        invoiceNumber: 'INV-2026-00039',
        companyName: 'Lumière Jewels',
        sellerName: 'Fine Jewellery',
        sellerCode: 'LMFJ08',
        serviceTypes: 'Rent',
        invoiceDate: '2026-04-12',
        dueDate: '2026-04-26',
        amount: -445,
    },
    {
        id: 5,
        invoiceNumber: 'INV-2026-00038',
        companyName: 'Red Oak Logistics',
        sellerName: 'Red Oak Logistics LLC',
        sellerCode: 'RED008',
        serviceTypes: 'Wallet Top-Up',
        invoiceDate: '2026-04-19',
        dueDate: '2026-04-19',
        amount: 5080,
    },
    {
        id: 6,
        invoiceNumber: 'INV-2026-00037',
        companyName: 'Nova Logistics LLC',
        sellerName: 'Nova Logistics LLC',
        sellerCode: 'NOVA06',
        serviceTypes: 'Outbound',
        invoiceDate: '2026-04-18',
        dueDate: '2026-05-02',
        amount: -890,
    },
    {
        id: 7,
        invoiceNumber: 'INV-2026-00036',
        companyName: 'Premium Goods Ltd',
        sellerName: 'Beauty',
        sellerCode: 'PGB100',
        serviceTypes: 'Rent',
        invoiceDate: '2026-04-10',
        dueDate: '2026-04-24',
        amount: -625,
    },
    {
        id: 8,
        invoiceNumber: 'INV-2026-00035',
        companyName: 'EcoWare Solutions',
        sellerName: 'Eco Products',
        sellerCode: 'ECS008',
        serviceTypes: 'Inbound',
        invoiceDate: '2026-04-08',
        dueDate: '2026-04-22',
        amount: 1950.75,
    },
];

// ============================================================================
// Data Transformation Functions - Convert API Response to Invoice Format
// ============================================================================

/**
 * Transforms a single API response item to the required invoice format
 * @param {Object} apiItem - Single item from API response (const data format)
 * @returns {Object} Transformed invoice object matching required format
 */
export const transformAPIResponseToInvoiceFormat = apiItem => {
    if (!apiItem) return null;

    // Extract date portion from ISO timestamp (e.g., '2026-01-04T20:24:34.137' -> '2026-01-04')
    const formatDateFromTimestamp = timestamp => {
        if (!timestamp) return '';
        return timestamp.split('T')[0];
    };

    return {
        id: apiItem.invoiceId,
        invoiceNumber: apiItem.invoiceNumber,
        companyName: apiItem.companySellerName, // Map companySellerName to companyName
        sellerCode: apiItem.sellerCode,
        serviceTypes: apiItem.transactionTypes, // Map transactionTypes to serviceTypes
        invoiceDate: formatDateFromTimestamp(apiItem.invoiceDate), // Use invoiceDate
        dueDate: formatDateFromTimestamp(apiItem.invoiceDate), // Use invoiceDate for dueDate
        amount: apiItem.totalAmount, // Map totalAmount to amount
        hasRentItems: apiItem.hasRentItems || false, // Determine billing cycle (Monthly for rent, Daily otherwise)
        status: apiItem.invoiceStatus,
        fromDate: formatDateFromTimestamp(apiItem.fromDate),
        toDate: formatDateFromTimestamp(apiItem.toDate),
    };
};

/**
 * Transforms an array of API response items to invoice format
 * @param {Array} apiResponseArray - Array of items from API response
 * @returns {Array} Array of transformed invoice objects
 */
export const transformInvoicesArray = apiResponseArray => {
    if (!Array.isArray(apiResponseArray)) {
        console.warn('Invalid input: apiResponseArray must be an array');
        return [];
    }

    return apiResponseArray.map(transformAPIResponseToInvoiceFormat).filter(invoice => invoice !== null);
};
